import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateAdditionalReport(
    $id: String!
    $data: updateAdditionalReportInput!
  ) {
    updateAdditionalReport(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateAdditionalReportRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateAdditionalReportInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'additional_report/update_additional_report',
  async (
  params: {id: String;data: TYPES.UpdateAdditionalReportInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateAdditionalReport;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateAdditionalReportSlice = createSlice({
  name: 'update_additional_report',
  initialState: initialState,
  reducers: {
    updateAdditionalReportClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateAdditionalReportRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateAdditionalReportRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateAdditionalReportRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateAdditionalReportClear } =
updateAdditionalReportSlice.actions;

export const updateAdditionalReport = createSelector(
  (state: RootState) => state.additionalReport.updateAdditionalReport.result,
  (state: RootState) => state.additionalReport.updateAdditionalReport.error,
  (state: RootState) =>
  state.additionalReport.updateAdditionalReport.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateAdditionalReportSlice.reducer;